<template>
  <div class="trello-multiple-media-input">
    <div class="form-group row">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <br/>
        <template v-if="!options.displayImages">
          <div v-for="(val, index) in value" :key="index" class="feedback">
            <i class="fa fa-file"></i> {{ val.fileName }}
            | <a v-show="val" :href="val.url" target="_blank" class="text-info"><i class="fa fa-search"></i> Preview</a>
            | <span class="interactive-cursor text-danger" @click="deleteImage(val)"><i class="fa fa-times"></i> Remove</span><br/>
          </div>
        </template>
        <draggable v-model="valArray" @end="validate(valArray)" v-else-if="draggable">
          <div class="defect-image" v-for="(val, index) in value" :key="index">
            <span class="defect-image-handle fa fa-bars"></span>
            <span @click="deleteImage(val)" class="defect-image-delete fa fa-trash red"></span>
             <img
              :key="val.key"
              target="_blank"
              class="amazon-preview img-fluid my-1"
              :src="val.url"/>
          </div>
        </draggable>
        <div class="defect-image" v-for="(val, index) in value" :key="index" v-else>
          <span @click="deleteImage(val)" class="defect-image-handle fa fa-trash red"></span>
            <img
            :key="val.key"
            target="_blank"
            class="amazon-preview img-fluid my-1"
            :src="val.url"/>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import Draggable from 'vuedraggable'
  import {
    validationClass,
    validationIcon,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'TrelloMultipleMediaInput',
    props: {
      value: {
        type: Array
      },
      options: {
        type: Object,
        default () {
          return {
            valid: false,
            dirty: false
          }
        }
      }
    },
    components: {
      Draggable
    },
    data () {
      return {
        progress: 0,
        draggable: false,
        isUploading: false,
        isDirty: false,
        isValid: false
      }
    },
    computed: {
      height () {
        return this.options.height || 'auto'
      },
      width () {
        return this.options.width || 'auto'
      },
      validationClass,
      validationIcon,
      validationMessage
    },
    methods: {
      deleteImage (image) {
        let values = this.value
        values.splice(values.indexOf(image), 1)
        this.valArray = values
        this.validate(values)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/inputs/TrelloMultipleMediaInput.vue